import { observer } from "mobx-react-lite";
import React from "react";
import { useSaveConfigManager } from "../hooks/useSaveConfigManager";
import { CompactView } from "./views/CompactView";
import { FormularView } from "./views/FormularView";
import { StepsView } from "./views/StepsView";

type Props = {};

export const TicketFormView = observer((props: Props) => {
  const saveConfig = useSaveConfigManager();
  const view = saveConfig.getView();

  return (
    <>
      {view === "formular" && <FormularView />}
      {view === "compact" && <CompactView />}
      {view === "steps" && <StepsView />}
    </>
  );
});
